export class GetLiveOpticsDataFromFileImport {
    static readonly type = '[Data Ingestion] Get LiveOptics Data from File Import';
    constructor(public file: any) { }
}

export class GetRVToolsDataFromFileImport {
    static readonly type = '[Data Ingestion] Get RV Tools Data from File Import';
    constructor(public file: any) { }
}

export class SetStateWithImportedFileInfo {
    static readonly type = '[Data Ingestion] Set the State with Imported File Info';
    constructor(public fileName: string | undefined, public parsedData: any, public selectedSource: string | undefined, public fileImported: boolean, public fileSize: number | undefined, public liveOpticsProjectId: string | undefined = undefined) { }
}